module.exports = __webpack_public_path__ + "static/media/corporate.66ae9102.svg";